import { tokenize } from "./Lexer.fs.js";
import { toList } from "./.fable/fable-library.3.2.9/Seq.js";
import { node_print, parse } from "./Parser.fs.js";
import { json_from_tree, print_tree, propopositional_solver } from "./Propositional.fs.js";

export function gen_interpretation(input) {
    const tokens = tokenize(toList(input));
    const ast = parse(tokens);
    return node_print(ast);
}

export function gen_text_tree(input) {
    const tokens = tokenize(toList(input));
    const ast = parse(tokens);
    const proof_tree = propopositional_solver(ast);
    return print_tree(proof_tree);
}

export function gen_tree(input) {
    const tokens = tokenize(toList(input));
    const ast = parse(tokens);
    const proof_tree = propopositional_solver(ast);
    return json_from_tree(proof_tree);
}

